import React from 'react'
import Register from '../pages/register/Register'
import FinishRegister from '../pages/register/FinishRegister'
import { Route, Routes } from 'react-router-dom'

export default function RegisterPage() {
    return (
        <Routes>
            <Route path='/' element={<Register />} />
            <Route path='/completed' element={<FinishRegister />} />
        </Routes>
    )
}
